'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('react');
require('classnames');
require('../Box/Box.js');
require('../../style-inject.es-dcee06b6.js');
require('../Icon/Icon.js');
require('../../icons/CloseOutline.js');
require('@reach/dialog');
require('@headlessui/react');
require('../CloseButton/CloseButton.js');
require('../Text/Text.js');
require('../../hooks/useId.js');
require('../../utils/noop.js');
var components_Dialog_Dialog = require('./Dialog.js');



exports.Dialog = components_Dialog_Dialog['default'];
exports.DialogBody = components_Dialog_Dialog.DialogBody;
exports.DialogContent = components_Dialog_Dialog.DialogContent;
exports.DialogFooter = components_Dialog_Dialog.DialogFooter;
exports.DialogHeader = components_Dialog_Dialog.DialogHeader;
exports.DialogHeaderGroup = components_Dialog_Dialog.DialogHeaderGroup;
exports.DialogOverlay = components_Dialog_Dialog.DialogOverlay;
exports.DialogSubTitle = components_Dialog_Dialog.DialogSubTitle;
exports.DialogTitle = components_Dialog_Dialog.DialogTitle;
